<div class="autoColGrid">
  <h4 class="header">{{ header }}</h4>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
